import Vue from "vue";
import Vuex, { Store } from "vuex";

Vue.use(Vuex);

const store = new Store({
  state: {
    buildVersion: "1.12",
    isScrolling: false,
    loading: false,
    todoList: [],
    jobs: null,
    site_info: {
        "phone": "+1 (415) 236-7688",
        "email": "sales@globaldev.io"
    },
    social_networks: [
      {
        "icon": "fab-facebook",
        "url": "https://www.facebook.com/globaldevio"
      },
      {
        "icon": "fab-linkedin",
        "url": "https://www.linkedin.com/company/globaldevio"
      },
      {
        "icon": "fab-instagram",
        "url": "https://www.instagram.com/globaldevio"
      }
    ]
  },
  getters: {
    getJobList(state){
      return state.jobs
    },
    getBuildVersion(state) {
      return state.buildVersion;
    },
    getTodoListLength(state) {
      return state.todoList.length;
    },
    getSiteInfo(state){
      return state.site_info
    },
    getSocialNetworks(state) {
      return state.social_networks;
    }
  },
  mutations: {
    mutate(state, payload) {
      Object.assign(state, payload);
    },
    setJobList(state, value){
      Object.assign(state, value)
    },
    setLoading(state, value) {
      state.loading = value;
    },
    addTodo(state, value) {
      state.todoList.push(value);
    },
    removeTodo(state, value) {
      state.todoList.splice(value, 1);
    }
  },
  actions: {
    async addTodoAsync({ commit, state }, text) {
      let value = null;
      commit("setLoading", true);
      try {
        value = await new Promise((resolve, reject) => {
          setTimeout(() => resolve(text), 500);
        });
      } catch (err) {}

      commit("setLoading", false);
      return value;
    },
    addTodo({ commit, state }, value) {
      commit("addTodo", value);
    },
    removeTodo({ commit, state }, value) {
      commit("removeTodo", value);
    }
  }
});

export { store };



// WEBPACK FOOTER //
// ./src/store/index.js